/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StoreManagementExportItemResponse } from './StoreManagementExportItemResponse';

export type StoreManagementExportItemResponseApiRespoonse = {
    data?: StoreManagementExportItemResponse;
    status?: StoreManagementExportItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace StoreManagementExportItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

